import { Amplitude } from './Amplitude';
import { Analytics } from './Analytics';
import { DummyAnalytics } from './DummyAnalytics';
import { Event } from './Event';
import { FacebookPixel } from './FacebookPixel';
import { GoogleAnalytics } from './GoogleAnalytics';

class AppAnalytics {
  private analytics: Analytics[];

  constructor(analytics: Analytics[]) {
    this.analytics = analytics;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  initialize() {}

  trackEvent(event: Event) {
    this.analytics.forEach((it: Analytics) => {
      if (it.supportedEvents.includes(event.name)) {
        it.trackEvent(event);
      }
    });
  }
}

export const appAnalytics = new AppAnalytics(
  process.env.NODE_ENV === 'production'
    ? [new GoogleAnalytics(), new FacebookPixel(), new Amplitude()]
    : [
        new DummyAnalytics(),
        new GoogleAnalytics(),
        new FacebookPixel(),
        new Amplitude(),
      ],
);
